/* RF3 2026-10-03: size tools for Rubber Feet Warehouse.
   1) Collection "Compare all sizes" strip (snippets/rfw-size-compare.liquid): on first open, fetches the collection's
      size data (templates/collection.rfwsizes.liquid, same filters/sort as the page) and renders a sortable table.
   2) Search size matcher (sections/main-search.liquid): parses fractions, mm, thread specs (5/16-18, #10-32) and AS568
      dash numbers (#017), fetches the matching category's size data and shows the exact size first plus the closest sizes.
   Data comes only from the products' own dimension metafields, price and availability. */
(function () {
  'use strict';

  function frac(v) {
    if (v == null) return NaN;
    var s = String(v).toLowerCase().replace(/["”″]|inch(es)?/g, '').trim();
    var m = s.match(/^(\d+)\s*[- ]\s*(\d+)\/(\d+)$/);
    if (m) return +m[1] + m[2] / m[3];
    m = s.match(/^(\d+)\/(\d+)$/);
    if (m) return m[1] / m[2];
    m = s.match(/^(\d*\.?\d+)\s*mm$/);
    if (m) return m[1] / 25.4;
    m = s.match(/^\d*\.?\d+$/);
    return m ? +s : NaN;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function normThr(s) { return String(s || '').toLowerCase().replace(/\s+/g, '').replace(/^#/, '#'); }
  function fam(ty) {
    ty = String(ty || '').toLowerCase();
    if (/grommet/.test(ty)) return 'grommet';
    if (/washer/.test(ty)) return 'washer';
    if (/o-ring/.test(ty)) return 'oring';
    if (/vibration|mount|adjustable|machine screw/.test(ty)) return 'mount';
    if (/hole plug|bumper\/hole|push/.test(ty)) return 'plug';
    if (/feet|foot/.test(ty)) return 'feet';
    return 'other';
  }
  function insShort(s) { s = String(s || ''); return s.replace(/Male/g, 'M').replace(/Female/g, 'F').replace(/\s*(to|\/)\s*/g, '/').replace(/Solid Rubber/i, 'solid'); }
  /* size label, key dimension and sort key for one product row */
  function row(it) {
    var f = fam(it.ty), size = '', key = '', sk = NaN;
    if (f === 'grommet') { size = it.id ? it.id + ' ID' : ''; key = [it.fits && /"/.test(it.fits) && it.fits.length < 9 ? 'fits ' + it.fits + ' hole' : '', it.gw ? it.gw + ' groove' : ''].filter(Boolean).join(' · '); sk = frac(it.id); }
    else if (f === 'washer') { size = [it.od && it.od + ' OD', it.id && it.id + ' ID'].filter(Boolean).join(' × '); key = it.th ? it.th + ' thick' : ''; sk = frac(it.od); }
    else if (f === 'oring') { size = it.dash ? '#' + String(it.dash).replace(/^-/, '') : (it.id || ''); key = [it.id && it.id + ' ID', it.cs && it.cs + ' CS'].filter(Boolean).join(' × '); sk = frac(it.id); }
    else if (f === 'mount') { size = [it.rd, it.rh].filter(Boolean).join(' × '); key = [it.thr, it.stud && (/^\d/.test(it.stud) ? it.stud + ' stud' : it.stud), it.ins && insShort(it.ins)].filter(Boolean).join(' · '); sk = frac(it.rd); }
    else if (f === 'plug') { size = it.od ? it.od + ' top' : ''; key = [it.fits && 'fits ' + it.fits + ' hole', it.gw && it.gw + ' panel'].filter(Boolean).join(' · '); sk = frac(it.od); }
    else if (f === 'feet') { size = [it.rd, it.rh].filter(Boolean).join(' × '); key = it.thr ? it.thr + ' thread' : (it.sh ? it.sh + ' screw hole' : ''); sk = frac(it.rd); }
    if (!size) size = it.t.length > 42 ? it.t.slice(0, 40) + '…' : it.t;
    return { f: f, size: size, key: key, sk: isNaN(sk) ? 999 : sk, it: it };
  }
  var cache = {};
  function load(url) {
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) { return JSON.parse(t); });
    return cache[url];
  }
  function dataUrl(base, extra) {
    var q = new URLSearchParams(extra || '');
    q.delete('page'); q.delete('view'); q.delete('section_id');
    q.set('view', 'rfwsizes');
    return base + '?' + q.toString();
  }

  /* ---------- 1) collection comparison strip ---------- */
  function initCompare(el) {
    var body = el.querySelector('.rfw-cmp__body'), done = false;
    el.addEventListener('toggle', function () {
      if (!el.open || done) return;
      done = true;
      load(dataUrl(el.getAttribute('data-rfw-cmp'), location.search)).then(function (d) {
        var rows = d.items.map(row), dir = 1, col = 'sk';
        function draw() {
          rows.sort(function (a, b) { var x = col === 'p' ? a.it.p - b.it.p : col === 'a' ? (b.it.a - a.it.a) : a.sk - b.sk || a.it.p - b.it.p; return x * dir; });
          var h = '<div class="rfw-cmp__tools"><label class="rfw-cmp__find"><span>Find a size</span><input type="search" inputmode="decimal" placeholder="e.g. 1/2 or 5/16-18" enterkeyhint="search"></label>'
            + '<span class="rfw-cmp__count">' + rows.length + (d.n > rows.length ? ' of ' + d.n : '') + ' sizes</span></div>'
            + '<div class="rfw-cmp__scroll"><table class="rfw-cmp__table"><caption class="visually-hidden">All sizes in this collection</caption><thead><tr>'
            + '<th scope="col"><button type="button" data-col="sk">Size</button></th><th scope="col">Key dimension</th><th scope="col"><button type="button" data-col="p">From</button></th><th scope="col"><button type="button" data-col="a">Stock</button></th></tr></thead><tbody>';
          rows.forEach(function (r) {
            h += '<tr data-s="' + esc((r.size + ' ' + r.key + ' ' + r.it.t).toLowerCase()) + '"><th scope="row"><a href="' + esc(r.it.u) + '">' + esc(r.size) + '</a>' + (r.key ? '<span class="rfw-cmp__k">' + esc(r.key) + '</span>' : '') + '</th><td>' + esc(r.key) + '</td><td>' + money(r.it.p) + '</td><td class="' + (r.it.a ? 'is-in' : 'is-out') + '">' + (r.it.a ? 'In stock' : 'Sold out') + '</td></tr>';
          });
          h += '</tbody></table></div>';
          body.innerHTML = h;
          body.querySelectorAll('[data-col]').forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-col') === col ? 'true' : 'false');
            b.addEventListener('click', function () { var c = b.getAttribute('data-col'); dir = c === col ? -dir : 1; col = c; draw(); });
          });
          var inp = body.querySelector('input');
          inp.addEventListener('input', function () {
            var q = inp.value.toLowerCase().replace(/["”″]/g, '').trim();
            body.querySelectorAll('tbody tr').forEach(function (tr) { tr.hidden = q && tr.getAttribute('data-s').replace(/"/g, '').indexOf(q) < 0; });
          });
        }
        draw();
      }).catch(function () {
        done = false;
        body.innerHTML = '<p class="rfw-cmp__msg">Could not load the size table. Use the size filters instead.</p>';
      });
    });
  }

  /* ---------- 2) search size matcher ---------- */
  function parseQuery(q) {
    var s = ' ' + q.toLowerCase().replace(/["”″]/g, ' ').replace(/\binch(es)?\b/g, ' ') + ' ';
    var out = { type: '', nums: [], thr: '', dash: '', hole: /\bfits?\b|\bholes?\b/.test(s) };
    if (/grommet/.test(s)) out.type = 'grommet';
    else if (/o-?rings?\b|\bas568/.test(s)) out.type = 'oring';
    else if (/washer/.test(s)) out.type = 'washer';
    else if (/mount|isolat|vibrat/.test(s)) out.type = 'mount';
    else if (/plug|push/.test(s)) out.type = 'plug';
    else if (/\bfeet\b|\bfoot\b|bumper/.test(s)) out.type = 'feet';
    if (!out.type && out.hole) out.type = 'grommet';
    var t = s.match(/(#\d{1,2}|\d+\/\d+|m\d+)\s*-\s*(\d{1,2})\b/);
    if (t) { out.thr = (t[1] + '-' + t[2]).replace(/\s/g, ''); s = s.replace(t[0], ' '); if (!out.type) out.type = 'mount'; }
    var d = s.match(/(?:#|\bas568\s*-?|\bdash\s*)\s*-?(\d{3})\b/) || (out.type === 'oring' && s.match(/(?:^|\s)-?(\d{3})(?=\s)/));
    if (d) { out.dash = d[1]; s = s.replace(d[0], ' '); if (!out.type) out.type = 'oring'; }
    var re = /(\d+)\s*[- ]\s*(\d+)\/(\d+)|(\d+)\/(\d+)|(\d*\.\d+|\d+)\s*mm|(\d*\.\d+)|\b(\d{1,2})\b/g, m;
    while ((m = re.exec(s))) {
      if (m[1]) out.nums.push(+m[1] + m[2] / m[3]);
      else if (m[4]) out.nums.push(m[4] / m[5]);
      else if (m[6]) out.nums.push(m[6] / 25.4);
      else if (m[7]) out.nums.push(+m[7]);
      else if (m[8] && +m[8] <= 12) out.nums.push(+m[8]);
    }
    return out;
  }
  var PRIMARY = { grommet: ['id', 'fits'], washer: ['od', 'id'], oring: ['id'], mount: ['rd'], feet: ['rd'], plug: ['fits', 'od'] };
  var ALL = { grommet: ['id', 'fits', 'gw', 'od'], washer: ['od', 'id', 'th'], oring: ['id', 'od', 'cs'], mount: ['rd', 'rh', 'stud'], feet: ['rd', 'rh', 'sh'], plug: ['fits', 'od', 'gw', 'stem'] };
  /* exact = every size in the query matches (first number against the family's main dimension, the rest against any
     dimension); rank 0/1 says which main dimension matched (e.g. grommet inside diameter before panel hole) */
  function score(it, q) {
    var f = fam(it.ty), r = { exact: true, dist: 0, rank: 0 };
    if (q.thr) { if (normThr(it.thr) !== normThr(q.thr)) { r.exact = false; var a = frac(String(it.thr || '').split('-')[0]), b = frac(q.thr.split('-')[0]); r.dist += 10 + (isNaN(a) || isNaN(b) ? 5 : Math.abs(a - b)); } }
    if (q.dash) { var dd = String(it.dash || '').replace(/^-/, ''); if (dd !== q.dash) { r.exact = false; r.dist += dd ? Math.abs(+dd - +q.dash) / 100 : 50; } }
    q.nums.forEach(function (n, i) {
      var keys = i === 0 ? (PRIMARY[f] || []).slice() : (ALL[f] || []), best = Infinity, bi = 0;
      if (i === 0 && q.hole && keys.indexOf('fits') > 0) keys.unshift(keys.splice(keys.indexOf('fits'), 1)[0]);
      keys.forEach(function (k, j) { var v = frac(it[k]); if (!isNaN(v) && Math.abs(v - n) < best) { best = Math.abs(v - n); bi = j; if (i === 0) r.mk = k; } });
      if (best > 0.002) r.exact = false;
      if (i === 0) r.rank = bi;
      r.dist += (best === Infinity ? 50 : best) * (i === 0 ? 2 : 1);
    });
    if (!q.nums.length && !q.thr && !q.dash) r.exact = false;
    return r;
  }
  var BADGE = { id: 'Exact ID', fits: 'Fits hole', od: 'Exact OD', rd: 'Exact size' };
  function card(r, badge) {
    var it = r.it;
    return '<li class="rfw-sm__card"><a href="' + esc(it.u) + '">'
      + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="rfw-sm__noimg"></span>')
      + '<span class="rfw-sm__txt"><span class="rfw-sm__size">' + esc(r.size) + (badge ? ' <span class="rfw-sm__badge">' + badge + '</span>' : '') + '</span>'
      + '<span class="rfw-sm__key">' + esc(r.key) + '</span>'
      + '<span class="rfw-sm__meta">' + money(it.p) + ' · <span class="' + (it.a ? 'is-in' : 'is-out') + '">' + (it.a ? 'In stock' : 'Sold out') + '</span></span></span></a></li>';
  }
  function initSearch(el) {
    var q = parseQuery(el.getAttribute('data-q') || '');
    var map = {};
    try { map = JSON.parse(el.getAttribute('data-colls') || '{}'); } catch (e) {}
    var base = map[q.type];
    var body = el.querySelector('.rfw-sm__body');
    if (!base || (!q.nums.length && !q.thr && !q.dash)) { body.innerHTML = base ? '<p class="rfw-sm__h"><a href="' + esc(base) + '">Browse every size in this category</a></p>' : ''; el.classList.add('is-ready'); return; }
    load(dataUrl(base, '')).then(function (d) {
      var rows = d.items.map(function (it) { var r = row(it); var s = score(it, q); r.exact = s.exact; r.dist = s.dist; r.rank = s.rank; r.mk = s.mk; return r; })
        .filter(function (r) { return q.type === 'feet' ? /feet|plug/.test(r.f) : r.f === q.type || (q.type === 'mount' && r.f === 'feet'); });
      var exact = rows.filter(function (r) { return r.exact; }).sort(function (a, b) { return a.rank - b.rank || (b.it.a - a.it.a) || a.it.p - b.it.p; });
      var close = rows.filter(function (r) { return !r.exact; }).sort(function (a, b) { return a.dist - b.dist || (b.it.a - a.it.a); });
      var label = el.getAttribute('data-label') || 'size';
      var h = '';
      if (exact.length) h += '<p class="rfw-sm__h">Exact size: ' + exact.length + ' match' + (exact.length > 1 ? 'es' : '') + '</p><ul class="rfw-sm__row" role="list">' + exact.slice(0, 8).map(function (r) { return card(r, BADGE[r.mk] || 'Exact'); }).join('') + '</ul>';
      else h += '<p class="rfw-sm__h">No exact match for “' + esc(label) + '”. Closest sizes:</p>';
      var cl = close.slice(0, exact.length ? 6 : 8);
      if (cl.length) h += (exact.length ? '<p class="rfw-sm__h rfw-sm__h--2">Closest sizes</p>' : '') + '<ul class="rfw-sm__row" role="list">' + cl.map(function (r) { return card(r, ''); }).join('') + '</ul>';
      h += '<p class="rfw-sm__all"><a href="' + esc(base) + '">See all ' + d.n + ' sizes</a></p>';
      body.innerHTML = h;
      el.classList.add('is-ready');
    }).catch(function () { body.innerHTML = '<p class="rfw-sm__h"><a href="' + esc(base) + '">Browse all sizes in this category</a></p>'; el.classList.add('is-ready'); });
  }

  window.rfwSizes = { parse: parseQuery, score: score, row: row, frac: frac };
  function init() {
    document.querySelectorAll('[data-rfw-cmp]').forEach(initCompare);
    document.querySelectorAll('[data-rfw-sizematch]').forEach(initSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
